import {
  FETCH_MASCOTA_INFO,
  SEND_MASCOTA,
  EDIT_MASCOTA,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_MASCOTA,
  FETCHED_MASCOTA,
  SUBMITED_MASCOTA,
  SUBMIT_MASCOTA_ERROR,
  RESET_MASCOTA_SUBMIT,
  CLEAR_ALERT_DIALOG,
  RESET_MASCOTA_PROCESSING,
  STARTED_MASCOTA_PROCESSING,
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  submited_mascota: false,
  processing_mascota: false,
  loading_mascotas: false,
  loading_mascota: false,
};

const getters = {
  is_loading() {
    return state.loading_mascotas;
  },
  colaborador_submited() {
    return state.submited_mascota;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  mascota_processing() {
    return state.processing_mascota;
  },
};

const actions = {
  [FETCH_MASCOTA_INFO](context, mascotaId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_MASCOTA);
      ApiService.query(`mascotas/${mascotaId}`)
        .then(({ data }) => {
          context.commit(FETCHED_MASCOTA);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_MASCOTA);
        });
    });
  },
  [SEND_MASCOTA](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.upload('mascotas', data)
        .then(({ data }) => {
          context.commit(SUBMITED_MASCOTA, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_MASCOTA_ERROR, [response.data.message]);
        });
    });
  },
  [EDIT_MASCOTA](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.upload(`mascotas/editar/${data.get('mascota_id')}`, data)
        .then(({ data }) => {
          context.commit(SUBMITED_MASCOTA, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_MASCOTA_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [FETCHING_MASCOTA](state) {
    state.loading_mascota = true;
  },
  [FETCHED_MASCOTA](state) {
    state.loading_mascota = false;
  },
  [SUBMITED_MASCOTA](state, data) {
    state.submited_mascota = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_MASCOTA_ERROR](state, data) {
    state.processing_mascota = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_MASCOTA_SUBMIT](state) {
    state.submited_mascota = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_MASCOTA_PROCESSING](state) {
    state.processing_mascota = false;
  },
  [STARTED_MASCOTA_PROCESSING](state) {
    state.processing_mascota = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
